/**
 * HTTP resposne Codes
 */
export const ResponseCodes = {
  /**
   * Successful request
   */
  success: 200,

  /**
   * Service could not understand the request
   */
  badRequest: 400,
  /**
   * User is not authorised
   */
  unauthorised: 401,

  /**
   * Permission denied 
   */
  forbidden: 403,

  /**
   * request path not found
   */
  notFound: 404,  

  /**
   * Request timeout 
   */
  timeOut: 408,

  /**
   * Request didn't pass business validation
   */
  businessValidation: 422, 

  /**
   * Unknown error in web service 
   */
  serverError: 500
};



// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-http-client/response-codes.ts